module.exports = __webpack_public_path__ + "img/scgplogo.7745e553.png";